import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICompanyAlertSettings } from '../../../message-models/company-alert-settings.interface';
import { CompanyAlertSettings } from '../../../message-models/company-alert-settings.class';

@Component({
  selector: 'app-alert-settings-editor',
  templateUrl: './alert-settings-editor.component.html',
  styleUrls: ['./alert-settings-editor.component.scss']
})

export class AlertSettingsEditorComponent implements OnInit {
  @Input() companyAlertSettings: ICompanyAlertSettings = new CompanyAlertSettings();
  @Input() editingType: boolean = false;
  @Input() saveAttempted: boolean = false;
  public elements: Array<unknown> = [];

  constructor() { }

  ngOnInit(): void {

  }

  addNewInput() {
    this.elements = [...this.elements, this.elements.length + 1];
  }
}
